// src/features/users/components/UserTenantCard.tsx
import { Card, formatPersianNumber } from '../../../app/components/foundation';
import type { UserTenant } from '../types/user.types';

export interface UserTenantCardProps {
  tenant: UserTenant | undefined;
}

/**
 * Workspace card: the tenant this user belongs to, plus their role
 * within it. `tenant` comes from the user detail response — a single
 * record, not a list, since a user belongs to exactly one tenant in
 * this data model (mirror of
 * tenants/components/TenantUsersCard.tsx's role labeling, but shown
 * as a field list since this card describes one relationship rather
 * than a list of users).
 */
export function UserTenantCard({ tenant }: UserTenantCardProps) {
  return (
    <Card className="vania-user-workspace-card">
      <h2 className="vania-user-workspace-card-title">تننت</h2>

      {!tenant ? (
        <p className="vania-user-workspace-empty">این کاربر به تننتی متصل نیست.</p>
      ) : (
        <dl className="vania-user-profile-field-grid">
          <div>
            <dt>نام تننت</dt>
            <dd>{tenant.tenantName}</dd>
          </div>
          <div>
            <dt>شناسه تننت</dt>
            <dd dir="ltr">{formatPersianNumber(tenant.tenantId)}</dd>
          </div>
          <div>
            <dt>نقش</dt>
            <dd>{tenant.role || '-'}</dd>
          </div>
        </dl>
      )}
    </Card>
  );
}
